import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_ORIGIN = 'https://www.staffingforce.nl';
const DEFAULT_TITLE =
  'Staffing Force – Detachering Finance & HR Amsterdam';
const DEFAULT_DESCRIPTION =
  'Staffing Force is hét duurzame detacheringsbureau in Amsterdam voor Finance, HR en Duurzaamheid. Werkzaam in heel Nederland. Interim management, werving & selectie en detavast. B Corp gecertificeerd, opgericht in 2007.';

const SEO = ({
  title,
  description,
  keywords = 'staffing force, detachering, finance, HR, interim management, werving selectie, detavast, duurzaamheidsconsultants, Amsterdam, B Corp, CSRD, ESG',
  image = 'https://customer-assets.emergentagent.com/job_staffforce-new-site/artifacts/8pffcrsv_image.png',
  url,
  type = 'website',
  article = null,
}) => {
  const finalTitle = title || DEFAULT_TITLE;
  const finalDescription = description || DEFAULT_DESCRIPTION;

  // Build canonical from pathname (avoids preview domain leaking into SEO)
  const path =
    typeof window !== 'undefined' ? window.location.pathname : '/';
  const pageUrl = url || `${SITE_ORIGIN}${path}`;

  return (
    <Helmet>
      <html lang="nl" />
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
      <meta name="author" content="Staffing Force B.V." />

      {/* Single canonical (production domain) */}
      <link rel="canonical" href={pageUrl} />

      {/* Hreflang for NL */}
      <link rel="alternate" hrefLang="nl" href={pageUrl} />
      <link rel="alternate" hrefLang="nl-NL" href={pageUrl} />
      <link rel="alternate" hrefLang="x-default" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:site_name" content="Staffing Force" />
      <meta property="og:locale" content="nl_NL" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={image} />

      {/* Article specific */}
      {article && <meta property="article:published_time" content={article.publishedTime} />}
      {article && <meta property="article:author" content={article.author} />}
    </Helmet>
  );
};

export default SEO;
